import Dashboard from "views/Dashboard.jsx";
import Content from "views/Content.jsx";
import Devices from "views/Devices.jsx";
import Reports from "views/Reports.jsx";
import Icons from "views/Icons.jsx";
import Map from "views/Map.jsx";
import Notifications from "views/Notifications.jsx";
import Rtl from "views/Rtl.jsx";
import TableList from "views/TableList.jsx";
import Typography from "views/Typography.jsx";
import UserProfile from "views/UserProfile.jsx";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-components",
    component: Dashboard,
    layout: "/admin"
  },

  {
    path: "/content",
    name: "Content",
//    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-video-66",
    component: Content,
    layout: "/admin"
  },

      {
    path: "/devices",
    name: "Devices",
//    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-tv-2",
    component: Devices,
    layout: "/admin"
  },
  {
    path: "/reports",
    name: "Reports",
//    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-paper",
    component: Reports,
    layout: "/admin"
  },

// Stuff

    /*
    {
    path: "/icons",
    name: "Icons",
    rtlName: "الرموز",
    icon: "tim-icons icon-atom",
    component: Icons,
    layout: "/admin"
  },
  {
    path: "/map",
    name: "Map",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    component: Map,
    layout: "/admin"
  },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: "tim-icons icon-bell-55",
    component: Notifications,
    layout: "/admin"
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "/admin"
  },
  {
    path: "/tables",
    name: "Table List",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-puzzle-10",
    component: TableList,
    layout: "/admin"
  },
  {
    path: "/typography",
    name: "Typography",
    rtlName: "طباعة",
    icon: "tim-icons icon-align-center",
    component: Typography,
    layout: "/admin"
  },
  {
    path: "/rtl-support",
    name: "RTL Support",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: Rtl,
    layout: "/rtl"
  }
*/


];
export default routes;
